import "../assets/styles/Propos.css"


function Propos() {
    return (
        <section id="Propos" className="propos">
            <h2>A propos de moi</h2>
            <p>Passionné par les technologies et le développement web, je suis en train de finaliser ma formation en tant que développeur web front-end.
                Mon parcours professionnel m'a conduit à une reconversion vers cette passion qui m'anime au quotidien.</p>
            
        </section>
    );
  }
  
  export default Propos;